export default __webpack_public_path__ + "6a2190992c14260c4cd34230ee9ea376.svg";